import { render } from "./widgets-side-menu-item-expanded.vue?vue&type=template&id=e2c93644&scoped=true"
import script from "./widgets-side-menu-item-expanded.vue?vue&type=script&setup=true&lang=js"
export * from "./widgets-side-menu-item-expanded.vue?vue&type=script&setup=true&lang=js"

import "./widgets-side-menu-item-expanded.vue?vue&type=style&index=0&id=e2c93644&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2c93644"],['__file',"src/components/card-component/widgets-side-menu-item-expanded.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e2c93644"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e2c93644', __exports__)) {
    api.reload('e2c93644', __exports__)
  }
  
  module.hot.accept("./widgets-side-menu-item-expanded.vue?vue&type=template&id=e2c93644&scoped=true", () => {
    api.rerender('e2c93644', render)
  })

}


export default __exports__